import { css } from "@microsoft/fast-element";
import { display, spacingHorizontalM, spacingVerticalM } from "@fluentui/web-components";
/** Card Header styles
 * @public
 */
export const styles = css `
  ${display("flex")}
  :host {
    position: relative;
    overflow: hidden;
  }

  ::slotted([slot="badge"]) {
    position: absolute;
    inset-inline-start: ${spacingHorizontalM};
    bottom: ${spacingVerticalM};
  }
  ::slotted(img) {
    overflow: hidden;
  }
`;
//# sourceMappingURL=card-preview.styles.js.map